// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"92984f83","249":"6997bab3","396":"e0240847","494":"f4432c6f","553":"cfaded06","655":"493e975e"}[chunkId] + ".chunk.css";
};